import {Link} from "react-router-dom";
import type {SpeciesListProps} from "./types";
import './species-list.scss';

export default function SpeciesList({items, fullWidth = false, className}: SpeciesListProps) {
    if (!items.length) return null;

    return (
        <div className={`species-list ${fullWidth ? 'species-list--fullwidth' : ''} ${className ?? ''}`.trim()}>
            {items.map(item => {
                const body = <>
                    <img src={item.imageUrl} alt="" />
                    <div className="species-list__body">
                        <strong>{item.commonName}</strong>
                        <em>{item.scientificName || 'Species detail unavailable'}</em>
                        {item.meta !== undefined ? item.meta : <div className="species-list__meta"><span>{item.observationCount.toLocaleString()} {item.observationCount === 1 ? 'observation' : 'observations'}</span></div>}
                        {item.footer !== undefined ? item.footer : <small>{item.lastSeen ? `Last seen ${item.lastSeen}` : 'Date unavailable'}</small>}
                    </div>
                    {item.lowerContent ? <div className="species-list__lower">{item.lowerContent}</div> : null}
                </>;

                return item.detailPath
                    ? <Link className="species-list__card" to={item.detailPath} key={item.id}>{body}</Link>
                    : <div className="species-list__card" key={item.id}>{body}</div>;
            })}
        </div>
    );
}
